import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import {
  competencyTemplateKeys,
  RequestTypes,
} from '@core/react-query/features/templates/competencyTemplates'
import {
  CompetencyTemplateVersion,
  ICompetencyTemplateVersion,
} from '@core/entities/competency/CompetencyTemplateVersion'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useGetCompetencyTemplateVersion = (
  payload: RequestTypes['getCompetencyTemplateVersion'],
  options?: UseQueryOptions<
    ICompetencyTemplateVersion,
    RequestErrorType,
    CompetencyTemplateVersion
  >,
) => {
  return useQuery({
    select: CompetencyTemplateVersion.new,
    ...competencyTemplateKeys.getVersion(payload),
    ...options,
  })
}
